import React from 'react';
import ReactDOM from 'react-dom';

import events from 'events.js';

import InsurerWidget from 'directory/components/InsurerWidget.js';

// delays execution of fn until after delay ms have passed since last call
function debounce(fn, delay) {
    let timeout;
    return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn(...args), delay);
    };
}

// function to send iframe and container height to parent window
function sendPostMessage() {
    const iframeHeight = document.body.scrollHeight + 50;
    const containerHeight = document.querySelector('.insurer-widget')
        .clientHeight;

    // TODO: replace '*' with trusted origin when known
    window.parent.postMessage({iframeHeight, containerHeight}, '*');
}

(async function () {
    await events.ready();
    const props = {};

    const referralsSection = document.getElementById('referrals-app');

    if (referralsSection) {
        const debouncedSend = debounce(sendPostMessage, 100);

        // get data attributes for disclaimer and placeholder from django template
        const {disclaimer, placeholder} = referralsSection.dataset;
        props.disclaimer = disclaimer;
        props.placeholder = placeholder;
        // set up a MutationObserver to watch for changes in the referrals section DOM tree
        const observe = new MutationObserver(debouncedSend);

        // start observing the referrals section for changes
        observe.observe(referralsSection, {
            attributes: true,
            childList: true,
            subtree: true,
        });

        // append the InsurerWidget component to the referrals section
        ReactDOM.render(<InsurerWidget {...props} />, referralsSection);
    }
})();
